/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        AgentVariableDistribution200ResponseInner,
        GameMetrics,
        GameMetricsAggregate,
    } from '../models/index';

            export interface GameMetricsAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                additional_filters?: object;
                aggregates?: Array<string>;
                having?: object;
                index_on?: string;
                label?: string;
                metrics?: Array<string>;
            }

            export interface GameMetricsFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                additional_filters?: object;
                label?: string;
            }

            export interface GameMetricsGetRequest {
                id: string;
            }

            export interface GameMetricsListRequest {
                additional_filters?: object;
                annotations?: Array<string>;
                label?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
            }

            export interface GameMetricsVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                additional_filters?: object;
                label?: string;
            }

        /**
        * 
        */
            export class GameMetricsApi extends runtime.BaseAPI {

            /**
            */
            async gameMetricsAggregateRaw(requestParameters: GameMetricsAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GameMetricsAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling gameMetricsAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling gameMetricsAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.label !== undefined) {
                            queryParameters['label'] = requestParameters.label;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/GameMetrics/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: GameMetricsAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GameMetricsAggregate>> {
                    const response = await this.gameMetricsAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async gameMetricsFieldValuesRaw(requestParameters: GameMetricsFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling gameMetricsFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling gameMetricsFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.label !== undefined) {
                            queryParameters['label'] = requestParameters.label;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/GameMetrics/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: GameMetricsFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.gameMetricsFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async gameMetricsGetRaw(requestParameters: GameMetricsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GameMetrics>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling gameMetricsGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/GameMetrics/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: GameMetricsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GameMetrics> {
                    const response = await this.gameMetricsGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async gameMetricsListRaw(requestParameters: GameMetricsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GameMetrics>>> {
            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.label !== undefined) {
                            queryParameters['label'] = requestParameters.label;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/GameMetrics/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: GameMetricsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GameMetrics>> {
                    const response = await this.gameMetricsListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async gameMetricsVariableDistributionRaw(requestParameters: GameMetricsVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AgentVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling gameMetricsVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling gameMetricsVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling gameMetricsVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling gameMetricsVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.label !== undefined) {
                            queryParameters['label'] = requestParameters.label;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/GameMetrics/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: GameMetricsVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AgentVariableDistribution200ResponseInner>> {
                    const response = await this.gameMetricsVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
